import * as React from 'react';

import * as styles from './TextAndIcon.css';

interface ITextAndIconProps {
  icon: React.ReactNode;
}

export const TextAndIcon: React.FC<React.PropsWithChildren<ITextAndIconProps>> = ({ children, icon }) => {
  return (
    <div className={styles['container']}>
      {icon}
      <div className={styles['children']}> {children}</div>
    </div>
  );
};
